import type { BasePageData } from '@/types'

export enum CompanyStatus {
  CONFIRMED = 'CONFIRMED', // Подтверждён
  DRAFT = 'DRAFT', // Черновик
  DELETED = 'DELETED', // Удалён
  /*ThirdParty Company statuses*/
  ACTIVE = 'ACTIVE', // Действующая
  LIQUIDATED = 'LIQUIDATED', // Ликвидирована
  LIQUIDATING = 'LIQUIDATING', // Ликвидируется
}

export interface CompanyUserListData extends BasePageData {
  data: UserItem[]
}

export interface CompanyListData extends BasePageData {
  data: CompanyParams[]
}

export interface ThirdPartyCompanyListData extends BasePageData {
  suggestions: ThirdPartyCompany[]
}

export interface CompanyParamsListData extends BasePageData {
  data: CompanyParams[]
}

export interface BankAccountList {
  data: BankInfo[]
}

export interface UserItem {
  id: number
  firstname: string
  lastname: string
  middlename: string
  service_number: string
  contacts: Contacts
}

export interface Contacts {
  type: string[]
  use_to_notify: boolean
  value: string
}

export interface Company {
  id?: number
  full_name: string
  short_name: string
  inn: string
  kpp: string
  ogrn: string
  phones: string[]
  legal_address: string
  physical_address: string
  status: string
  short_title: string
}

export interface ThirdPartyCompany {
  value: string
  data: {
    name: {
      full: string
      short: string
      full_with_opf: string
      short_with_opf: string
    }
    inn: string
    kpp: string
    ogrn: string
    opf: {
      short: string
    }
    phones: string[]
    address: {
      value: string
    }
    state: {
      status: string
    }
  }
}

export interface CompanyParams {
  id?: number
  title?: string
  short_title?: string
  inn?: string
  kpp?: string
  ogrn?: string
  phone_number?: string
  legal_address?: string
  phys_address?: string
  status?: CompanyStatus
  companyType?: CompanyType[]
  signatureSystemType?: string
}

export interface CompanyQueryParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query?: any
}

export interface BankInfo {
  id?: number
  companyId?: number
  number?: string
  bank_name?: string
  name?: string
  status?: string
  is_main?: boolean
}

export interface CompanyType {
  companyId?: number
  companyTypeId: number
}

export enum ContactType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum EmployeeTableDocStatus {
  MISSED = 'Отсутствует',
  ACTUAL = 'Актуальные',
  PROCESSING = 'На проверке',
  ERROR = 'С ошибкой',
  NEW = 'Новый',
  EXPIRED = 'Просрочен',
}

export interface Employee {
  id?: number
  lastname?: string | null
  firstname?: string | null
  middlename?: string | null
  snils?: string | null
  gender?: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  birthdate?: any | null
  email?: string | null
  phone?: string | null
  service_number?: string | null
  position?: Position | null // For GET request only
  positionId?: number | null // for POST/PATCH request only
  // department?: Subdivision | null  // For GET request only
  departmentId?: number | null // for POST/PATCH request only
  roleId?: number | null
  contacts?: Contact[] | null
  status?: string
  //roles?:          number[]    | null
  is_new?: boolean | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  documents?: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  products?: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  roles?: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  branchIds?: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  branchAdmin?: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  branches?: any | null
  password?: string | null
  notify_by_email?: boolean | null
}

export interface Contact {
  id?: number | null
  type: ContactType
  use_to_notify: boolean
  value: string
}

export interface Position {
  id?: number
  name: string
}
